import React from 'react';

export function formatAtributeName(string) {
  const newString = string.replace(/_/g, ' ');
  if (newString === 'rl') {
    return <span>R<sub>L</sub></span>; // eslint-disable-line
  } else if (newString === 'qd') {
    return 'Qd';
  } else if (newString === 'rw') {
    return 'RW';
  } else if (newString === 'grit beads') {
    return 'Glass beads';
  } else if (newString === 'date') {
    return 'Measuring date';
  } else if (newString === 'street') {
    return 'Road/Street';
  }
  return newString.charAt(0).toUpperCase() + newString.slice(1);
}



// WEBPACK FOOTER //
// ./src/services/formatAtributeName.js